<template>
  <teleport to="body">
    <div
      v-if="isLoading"
      class="fixed inset-0 bg-slate-50/50 z-999999 flex flex-col items-center justify-center loading-dim"
    >
      <div class="spinner-wrapper">
        <svg class="loading-spinner" viewBox="0 0 50 50">
          <circle class="loading-circle" cx="25" cy="25" r="20" />
        </svg>
        <p v-if="loadingPercent > 0" class="loading-percent">{{ loadingPercent }}%</p>
      </div>
      <p v-if="loadingMessage" class="loading-message">{{ loadingMessage }}</p>
    </div>
  </teleport>
</template>
<script lang="ts" setup>
  import { watch } from 'vue'

  const props = defineProps<{
    isLoading: boolean
    loadingPercent: number
    // 스피너 아래 안내 문구 (예: "표를 분석하고 있어요…")
    loadingMessage?: string
  }>()

  watch(
    () => props.isLoading,
    () => {
      if (props.isLoading) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = 'auto'
      }
    },
  )
</script>

<style scoped lang="scss">
  .loading-dim {
    background-color: rgba(255, 255, 255, 0.3);
    backdrop-filter: blur(3px);
  }
  .loading-spinner {
    width: 50px;
    height: 50px;
    animation: rotate 1s linear infinite;
  }
  .loading-circle {
    fill: none;
    stroke: var(--Primary-500, #0064ff);
    stroke-width: 6;
    stroke-linecap: round;
    animation: dash 2s ease-in-out infinite;
  }
  .spinner-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .loading-percent {
    position: absolute;
    color: var(--Gray-800);
    font-size: 14px;
    font-weight: 600;
    margin: 0;
  }

  .loading-message {
    margin-top: 14px;
    color: var(--Gray-800);
    font-size: 14px;
    font-weight: 600;
    text-align: center;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
</style>
